import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/suite/:suiteId/animal/:animalIndex',
      name: 'attract',
      component: require('views/Attract')
    },
    {
      path: '/suite/:suiteId/animal/:animalIndex/attract',
      redirect: { name: 'attract' }
    },
    {
      path: '/suite/:suiteId/animal/:animalIndex',
      name: 'browser',
      component: require('views/Browser'),
      children: [
        {
          path: 'about',
          name: 'about',
          component: require('views/About')
        },
        {
          path: 'meet',
          name: 'meet',
          component: require('views/Meet')
        },
        {
          path: 'adopt',
          name: 'adopt',
          component: require('views/Adopt')
        },
        {
          path: 'learn',
          name: 'learn',
          component: require('views/Learn')
        },
        {
          path: 'the-bond',
          name: 'the-bond',
          component: require('views/TheBond')
        },
        {
          path: 'share',
          name: 'share',
          component: require('views/Share')
        },
        {
          path: 'favorites',
          name: 'favorites',
          component: require('views/Favorites')
        },
        {
          path: 'adopted',
          name: 'adopted',
          component: require('views/Adopted')
        }
      ]
    },
    {
      path: '/suite/:suiteId',
      redirect: to => {
        return {
          name: 'attract',
          params: {
            suiteId: to.params.suiteId,
            animalIndex: 1
          }
        }
      }
    },
    {
      path: '/',
      redirect: to => {
        return {
          name: 'attract',
          params: {
            suiteId: 202,
            animalIndex: 1
          }
        }
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js